import { render, staticRenderFns } from "./CurationFilterRequestLayout.vue?vue&type=template&id=4ce34a99&scoped=true"
import script from "./CurationFilterRequestLayout.vue?vue&type=script&lang=js"
export * from "./CurationFilterRequestLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce34a99",
  null
  
)

export default component.exports